import { render, staticRenderFns } from "./BlogTypeInput.vue?vue&type=template&id=233bc0a6&scoped=true&"
import script from "./BlogTypeInput.vue?vue&type=script&lang=js&"
export * from "./BlogTypeInput.vue?vue&type=script&lang=js&"
import style0 from "./BlogTypeInput.vue?vue&type=style&index=0&id=233bc0a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233bc0a6",
  null
  
)

export default component.exports